<div class="container">

    <p class="txt_nome_escola">{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>

    <div *ngIf="isLoading" class="loading">
        <mat-spinner></mat-spinner>
    </div>

    <mat-card class="card" *ngIf="!isLoading">
        <mat-card-content>
            <div class="btn_imprime_boleto" *ngIf="forma_pagamento == 3">
                <button mat-raised-button color="primary" (click)="imprimeBoleto()">
                    <mat-icon class="mat-18">download</mat-icon>
                    Baixar Boleto
                </button>
            </div>

            <header class="cliente_responsavel">
                <p class="txt_numero_pedido">Número do Pedido: {{ numero_pedido }}</p>
                <p class="txt_cliente">Nome Responsável: {{ nome_responsavel }}</p>
            </header>

            <section class="container_table" *ngFor="let dependente of dependentes">
                <div class="descricao_table">
                    <span class="txt txt_dependente"><strong>Aluno: </strong>{{dependente.nome_dependente}}</span>
                    <span class="txt txt_ano"><strong>Série: </strong>{{  dependente.produtos[0].serie.descricao }}</span>
                </div>

                <table mat-table [dataSource]="dependente.produtos">
                    <!-- Descrição do Produto -->
                    <ng-container matColumnDef="desc_produto">
                        <th mat-header-cell *matHeaderCellDef>Descrição</th>
                        <td mat-cell *matCellDef="let element"> {{element.desc_produto}} </td>
                        <td mat-footer-cell *matFooterCellDef>SubTotal</td>
                    </ng-container>
                    <!-- Valor -->
                    <ng-container matColumnDef="valor">
                        <th mat-header-cell *matHeaderCellDef> Valor </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.valor_total | currency:'BRL':'symbol':'1.2-2' }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef>
                            <!-- Exibe o valor do dependente atual -->
                            {{ totalPorDependente[dependente.id_dependente] ? (totalPorDependente[dependente.id_dependente] | currency:'BRL':'symbol':'1.2-2') : 0 | currency:'BRL':'symbol':'1.2-2'}}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                </table>
            </section>

            <section class="info_frete">
                <p class="txt_frete"><strong>Frete:</strong> {{ frete == 0 ? 'Grátis' : (frete | currency:'BRL':'symbol':'1.2-2')}}</p>
                <mat-divider></mat-divider>
                <p class="txt_total"><strong>Total do carrinho + Frete:</strong> <strong>{{ (frete + total) | currency:'BRL':'symbol':'1.2-2'}}</strong></p>
                <mat-divider class="com_margin"></mat-divider>
            </section>

            <section class="info_entrega">
                <h3>Prazo de Entrega:</h3>
                <p>{{ prazo_entrega }}</p>

                <h3>Endereço de Entrega:</h3>
                <p>{{ endereco }}</p>
            </section>

            <mat-divider class="mat-divider-margin"></mat-divider>

            <section>
                <h3>Forma de Pagamento:</h3>              
                <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 16px;" *ngIf="forma_pagamento == 1">
                    <p class="cartao_de_credito">Cartão de Crédito - {{ parcela }}<img [src]="caminhoBandeira" alt="Card Brand" width="50px" /></p>
                </div>

                <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 16px;" *ngIf="forma_pagamento == 3">
                    <p>Boleto:</p>
                    <img src="../../../assets/boleto.png" alt="Código de barras" width="70px">
                </div>

                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-bottom: 16px;" *ngIf="forma_pagamento == 4">
                  <img [src]="'data:image/png;base64,' + qrCodeImgBase64()" alt="QrCode" width="224px" height="224px">
                  <p><b>PIX QrCode:</b></p>

                  <mat-form-field appearance="outline" class="input-70">
                    <mat-label>PIX Copia e Cola</mat-label>
                    <input matInput formControlName="voucher" #pixCopiaColaInput [value]="pixCopiaCola()" readonly />
                    <button matSuffix mat-icon-button type="button" matTooltip="Copiar"
                      [cdkCopyToClipboard]="pixCopiaColaInput.value" *ngIf="pixCopiaColaInput.value !== ''">
                      <mat-icon class="mat-18">content_copy</mat-icon>
                    </button>
                  </mat-form-field>

                  <p style="color: #ff0000;"><b>{{validadeTexto()}}</b></p>
                </div>

                <div class="btn_imprime_boleto" *ngIf="forma_pagamento == 3">
                    <button mat-raised-button color="primary" (click)="imprimeBoleto()">
                        <mat-icon class="mat-18">download</mat-icon>
                        Baixar Boleto
                    </button>
                </div>

                <!-- <p class="txt_aviso">*Verifique se você tem bloqueador de popups ativado.</p> -->
            </section>

            <mat-divider class="mat-divider-margin"></mat-divider>

            <section id="observacao">
                <h3>Observação:</h3>
                <p *ngIf="forma_pagamento == 4">Esse pedido será enviado após a confirmação do pagamento via PIX.</p>
                <p *ngIf="forma_pagamento == 3">Esse pedido será enviado após o pagamento do boleto.</p>
                <p *ngIf="forma_pagamento == 1">Seu pagamento foi aprovado.</p>
            </section>

            <div class="btn_imprime_boleto">
                <button mat-raised-button color="primary" (click)="imprimeRecibo()">
                    <mat-icon class="mat-18">print</mat-icon>
                    Imprimir Recibo
                </button>
            </div>

            <!-- <label id="radio-group-label">Forma de entrega: </label>
            <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" [(ngModel)]="formaSelecionada">
                <mat-radio-button class="radio-button" *ngFor="let forma of forma_entrega" [value]="forma.id_forma">
                    {{forma.descricao}}
                </mat-radio-button>
            </mat-radio-group> -->

        </mat-card-content>
    </mat-card>
</div>
